import space from '../namespace';
import defaultState, { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.consult]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  >,
): IState => {
  const { type, namespace = space.consult, payload } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.UPDATE_CONSULT_CHANNEL_LIST]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelList: payload
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_CONSULT_ARTICAL_LIST]: {
      const _state = state[namespace as space.consult];
      return {
        ...state,
        [namespace]: {
          ..._state,
          articalList: { ...(_state?.articalList || {}), ...payload },
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_CONSULT_CHANNEL_ACTIVE_KEYS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelActiveKeys: payload,
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_CONSULT_CHANNEL_SORT_KEY_MAP]: {
      const _state = state[namespace as space.consult];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelSortKeyMap: { ...(_state?.channelSortKeyMap || {}), ...payload },
        }
      }
    }
    default:
      return state;
  }
};

export default reducer;
